import { GenericHeader, SearchBar } from 'components';
import ListComp from 'components/ListComp';
import React from 'react';
import { Teacher } from 'services';
import { Results } from './components';
import { account_manager } from 'utils/constants';
const TeacherList = props => {

  const Head = props => {
    let { handleCreateOpen, ...rest } = props; // eslint-disable-line
    return (
      <GenericHeader header="All Teachers" subheader="Teacher Management" {...rest} >
      </GenericHeader>
    );
  }

  return (
    <ListComp
      listing={Teacher.list}
      title="Teachers"
      name="teachers"
      searchable
      SearchBar={SearchBar}
      Header={Head}
      Results={Results}
      roles={[account_manager]}
      filters={{ limit: 10, offset: 0, count: 0, search: "", type: "" }}
    />
  );
};

export default TeacherList;
